import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BehaviorSubject, debounceTime, startWith, map } from 'rxjs';
import { CopyFYDialogData } from 'src/app/page/masterdata/apr-rates/apr-rates.component';

@Component({
  selector: 'app-copy-apr-rates',
  templateUrl: './copy-apr-rates.component.html',
  styleUrls: ['./copy-apr-rates.component.scss'],
  standalone: false // NOSONAR
})
export class CopyAprRatesComponent implements OnInit {

  enableError: boolean = false;
  selected_fiscalyear;
  fiscalyearDesc
  targetFY;
  fiscalYearDrpDwn;

  action;
  heading;
  errormsg: string;
  fiscalYearData: any;
  temp: string;

  usertemp: string;
  userInfo: any;
  strUserName;

  dynamicHeight: number;
  fiscalYearFilterControl = new FormControl('');
  filteredFiscalYears = new BehaviorSubject<any[]>([]);
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly dialogRef: MatDialogRef<CopyAprRatesComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: CopyFYDialogData) {

    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.ngxUiLoaderService.start("loader-01");

    //fetch from local-storage
    this.temp = localStorage.getItem('fiscal-year-data');
    this.fiscalYearData = JSON.parse(this.temp);
    const temp = [];
    let obj;

    this.fiscalYearData.forEach(element => {
      obj = { "label": element.fiscalYear, "value": element.fiscalYear };
      temp.push(obj);
    });
    this.fiscalYearDrpDwn = temp;
    console.log("----------------this.fiscalYearDrpDwn ", this.fiscalYearDrpDwn);
    //fetch from local-storage
    // this.usertemp = localStorage.getItem('user-info');
    // this.userInfo = JSON.parse(this.usertemp);
    // this.strUserName = this.userInfo[0].strUserName; // Commented to get the same info from FGA

    this.usertemp = sessionStorage.getItem('FGA');
    this.userInfo = JSON.parse(this.usertemp);
    this.strUserName = this.userInfo?.user?.userPrincipalName;

    this.ngxUiLoaderService.stop("loader-01");

    if (this.dataStore.performAction == 'CopyCell') { // NOSONAR
      this.action = 'CopyCell';
      this.fiscalYearData.filter(x => x.fiscalYear == this.dataStore.placeholder_srcFY).forEach(e => { // NOSONAR
        this.fiscalyearDesc = e.fiscalYear;
      });

      this.selected_fiscalyear = { "label": this.fiscalyearDesc, "value": this.dataStore.placeholder_srcFY };
    }
  }

  ngOnInit(): void { // NOSONAR 

    this.filteredFiscalYears.next(this.fiscalYearDrpDwn.slice());

    // Filter on search
    this.fiscalYearFilterControl.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      map(search =>
        search
          ? this.fiscalYearDrpDwn.filter(item =>
            item.label?.toString().toLowerCase().includes(search.toLowerCase())
          )
          : this.fiscalYearDrpDwn
      )
    ).subscribe(filtered => {
      this.filteredFiscalYears.next(filtered);
      console.log("filtered ", filtered);
      console.log("this.filteredFiscalYears ", this.filteredFiscalYears);
      console.log("this.fiscalYearDrpDwn ", this.fiscalYearDrpDwn);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  public saveClick() {
    console.info("Fiscal Year from the dialog", this.selected_fiscalyear);
    console.info("Target Fiscal Year from the dialog", this.targetFY);
    console.info("User from the dialog", this.strUserName);

    if (this.selected_fiscalyear == null || this.selected_fiscalyear == undefined || this.targetFY == undefined || this.targetFY == null) { // NOSONAR
      this.enableError = true;
      this.errormsg = 'Please fill in the required fields!';
    }
    else {
      this.dialogRef.close({
        event: this.action, data1: this.selected_fiscalyear.value, data2: this.targetFY, data3: this.strUserName
      });
    }
  }
}
